/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Is_This_A_PdfInputs */

const en_mobile_is_this_a_pdf = /** @type {(inputs: Mobile_Is_This_A_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this a PDF?`)
};

const es_mobile_is_this_a_pdf = /** @type {(inputs: Mobile_Is_This_A_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es este un PDF?`)
};

/**
* | output |
* | --- |
* | "Is this a PDF?" |
*
* @param {Mobile_Is_This_A_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_is_this_a_pdf = /** @type {((inputs?: Mobile_Is_This_A_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Is_This_A_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_is_this_a_pdf(inputs)
	return en_mobile_is_this_a_pdf(inputs)
});